import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import createPersistedState from "vuex-persistedstate";
import { hostname } from "@/utils";
import SecureLS from "secure-ls";

const ls = new SecureLS({ isCompression: true });

Vue.use(Vuex);
const debug = process.env.NODE_ENV !== "production";
const store = new Vuex.Store({
  plugins: [
    createPersistedState({
      storage: {
        getItem: (key) => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: (key) => ls.remove(key),
      },
    }),
  ],
  state: {
    isLoading: false,
    currentUser: {},
    sessionScope: {},
    routeParams: {},
    csrfToken: {},
    currentMenu: 0,
  },
  getters: {
    isLoading: (state) => state.isLoading,
    routeParams: (state) => state.route.params,
    currentUser: (state) => state.currentUser,
    sessionScope: (state) => state.sessionScope,
    csrfToken: (state) => state.csrfToken,
    currentMenu: (state) => state.currentMenu,
  },
  actions: {
    getCheckSession({ commit }) {
      return Vue.prototype.submit(`${hostname}/api/login/session/check`, {}, false).then(({ data }) => {
        // console.log("getCheckSession", data);
        if (data != "OK") {
          localStorage.removeItem("SET_CURRENT_USER");
          axios.defaults.headers.common["X-Auth-Token"] = null;
          commit("REMOVE_CURRENT_USER");

          if (Vue.prototype.isApp()) {
            window.ReactNativeWebView.postMessage(JSON.stringify({ action: "logout" }));
          }
        }
      });
    },
    setSessionRetrive({ commit }) {
      return Vue.prototype.submit(`${hostname}/api/login/session/retrive`, {}, false).then(({ data }) => {
        // console.log("getCheckSession", data);
        var result = data.result;
        if (data.status != null && data.status == "OK" && result != null && result.ssnId != null) {
          // 헤더에 인증정보 생성
          axios.defaults.headers.common["X-Auth-Token"] = `${result.ssnId}`;
          result.isAuthenticated = true;
          commit("SET_CURRENT_USER", result);

          if (Vue.prototype.isApp()) {
            window.ReactNativeWebView.postMessage(JSON.stringify({ action: "devicetoken", userId: result.loginId, ssnId: result.ssnId }));
          }
        }
      });
    },
    setLogin({ commit }, dataMap) {
      return Vue.prototype.submit(`${hostname}/user/login`, dataMap, true, { "content-type": "application/x-www-form-urlencoded;charset=UTF-8" }).then(({ data }) => {
        // console.log("setLogin", data);
        var result = data.result;
        result.status = data.status;
        if (result.status == "OK" && result.loginId != null) {
          // 헤더에 인증정보 생성
          axios.defaults.headers.common["X-Auth-Token"] = `${result.ssnId}`;
          result.isAuthenticated = true;

          if (Vue.prototype.isApp()) {
            window.ReactNativeWebView.postMessage(JSON.stringify({ action: "devicetoken", userId: result.loginId, ssnId: result.ssnId }));
          }

          commit("SET_CURRENT_USER", result);
        }
        return result;
      });
    },
    setLoginMbl({ commit }, result) {
      if (result.userId != null) {
        // 헤더에 인증정보 생성
        axios.defaults.headers.common["X-Auth-Token"] = `${result.ssnId}`;
        result.isAuthenticated = true;

        if (Vue.prototype.isApp()) {
          window.ReactNativeWebView.postMessage(JSON.stringify({ action: "devicetoken", userId: result.loginId, ssnId: result.ssnId }));
        }
        commit("SET_CURRENT_USER", result);
      }
    },
    getCsrfToken({ commit }) {
      return Vue.prototype.submit(`${hostname}/api/token/csrf`, dataMap).then(({ data }) => {
        commit("SET_CSRF_TOKEN", data);
      });
    },
    setLogout({ commit }) {
      return Vue.prototype.submit(`${hostname}/api/logout`, {}).then(({ data }) => {
        // console.log(data);
        localStorage.removeItem("SET_CURRENT_USER");
        axios.defaults.headers.common["X-Auth-Token"] = null;
        commit("REMOVE_CURRENT_USER");

        if (Vue.prototype.isApp()) {
          window.ReactNativeWebView.postMessage(JSON.stringify({ action: "logout" }));
        }
      });
    },
    setSessionScope({ commit }, session) {
      commit("SET_SESSION_SCOPE", session);
    },
    setCurrentMenu({ commit }, menuId) {
      commit("SET_CURRENT_MENU", menuId);
    },
    removeCurrentMenu({ commit }) {
      commit("REMOVE_CURRENT_MENU");
    },
    showLoading({ commit }) {
      commit(types.SHOW_LOADING);
    },
    hideLoading({ commit }) {
      commit(types.HIDE_LOADING);
    },
  },
  mutations: {
    SET_CURRENT_USER(state, user) {
      state.currentUser = user;
    },
    REMOVE_CURRENT_USER(state) {
      state.currentUser = {};
    },
    SET_SESSION_SCOPE(state, session) {
      state.sessionScope = { ...state.sessionScope, ...session };
      // console.log("state.sessionScope", state.sessionScope);
    },
    SET_CURRENT_MENU(state, menuId) {
      // console.log("SET_CURRENT_MENU", menuId);
      state.currentMenu = menuId;
    },
    REMOVE_CURRENT_MENU(state) {
      // console.log("REMOVE_CURRENT_MENU");
      state.currentMenu = null;
    },
    SHOW_LOADING(state) {
      state.isLoading = true;
    },
    HIDE_LOADING(state) {
      state.isLoading = false;
    },
  },
  strict: debug,
});

export default store;
